import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useCallback, useEffect, type ComponentProps } from 'react';
import { Drawer, DrawerClose, DrawerContent, DrawerTitle } from '../../../../design-system/drawer/drawer';
import { InvoiceDrawerContent } from './invoice-drawer-content';

type InvoiceDrawerArgs = {
  isOpen: boolean;
  invoiceDrawerContentConfig: ComponentProps<typeof InvoiceDrawerContent>;
  onClose: () => void;
};

export const InvoiceDrawer = ({ isOpen, invoiceDrawerContentConfig, onClose }: InvoiceDrawerArgs) => {
  const cachedOnPrevious = useCallback(() => {
    if (invoiceDrawerContentConfig.navigationConfig.isVisible) {
      invoiceDrawerContentConfig.navigationConfig.onPrevious();
    }
  }, [invoiceDrawerContentConfig.navigationConfig]);

  const cachedOnNext = useCallback(() => {
    if (invoiceDrawerContentConfig.navigationConfig.isVisible) {
      invoiceDrawerContentConfig.navigationConfig.onNext();
    }
  }, [invoiceDrawerContentConfig.navigationConfig]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        cachedOnPrevious();

        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        cachedOnNext();

        return;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, cachedOnNext, cachedOnPrevious]);

  return (
    <Drawer open={isOpen} onOpenChange={onClose} direction="right" modal={true}>
      <DrawerContent aria-describedby={undefined} className="data-[vaul-drawer-direction=right]:p-0">
        <VisuallyHidden>
          <DrawerTitle>Invoice Drawer</DrawerTitle>
        </VisuallyHidden>

        <DrawerClose />

        <InvoiceDrawerContent {...invoiceDrawerContentConfig} />
      </DrawerContent>
    </Drawer>
  );
};
